/**
 * ResourcesPage — the standalone /resources route.
 *
 * Renders the shared ResourceDirectory (Clockify people directory + admin "Sync from Clockify"
 * action) with its page header. The same directory is also reachable from Settings → Resources.
 */
import { ResourceDirectory } from '@/components/resources/ResourceDirectory';

function ResourcesPage(): JSX.Element {
  return (
    <div className="space-y-6">
      <ResourceDirectory showHeader />
    </div>
  );
}

export default ResourcesPage;
